module.exports={account_link_complete_message:"การลิงก์บัญชี Nexon เสร็จสมบูรณ์"};